var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[(!_vm.showData)?_c('PageHeader',{attrs:{"title":_vm.title}}):_vm._e(),(_vm.showData)?_c('div',{staticStyle:{"padding":"10px 20px"}},[_c('media-stat')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }